export const FOLLOWERS_ON_PROJECT_EXPERIMENT = 'followers-visible-on-project';

export const ATLAS_JIRA_GET_ATLAS_FREE = 'atlas_jira_get_atlas_free';
export const ATLAS_JIRA_SEARCH_JIRA_ISSSUES = 'atlas_jira_search_jira_issues';
export const ROVO_SEARCH_COMPARE_RESULTS_PASS_THROUGH_RATE = 'rovo-search-compare-results-pass-through-rate';

// Nav refresh 'beta' experiments
// https://hello.atlassian.net/wiki/spaces/JNR/pages/3699574590/Rollout+technical+design#Beta
export const NAV_REFRESH_FREE_CUSTOMERS_EXP = 'jira_nav4_beta_free-customers';
export const NAV_REFRESH_NEW_CUSTOMERS_EXP = 'jira_nav4_beta_new-customers';
export const NAV_REFRESH_NEW_CUSTOMERS_X_EXP = 'confluence_jira_nav4_new_customers';

// https://switcheroo.atlassian.com/ui/gates/38c4ae74-29c2-4851-a010-866e2c0725aa/key/metrics_improvements_seq_experiment
export const METRICS_IMPROVEMENTS_SEQ_EXPERIMENT = 'metrics_improvements_seq_experiment';

// https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/townsquare_starred_feed/setup
export const TOWNSQUARE_STARRED_FEED = 'townsquare_starred_feed';

// https://switcheroo.atlassian.com/ui/gates/f0c8695a-3334-4f50-99e2-cecd6570ea6d/key/atlassian_projects_-_native_integration
export const PROJECTS_NATIVE_INTEGRATION_WITH_JIRA = 'atlassian_projects_-_native_integration';

// https://switcheroo.atlassian.com/ui/gates/c7385bcf-6769-4450-84bb-73f75f588796/key/navx_uc_frequency_ordering_and_overflow
export const NAVX_UC_FREQUENCY_ORDERING_AND_OVERFLOW = 'navx_uc_frequency_ordering_and_overflow';

// https://switcheroo.atlassian.com/ui/gates/99f42805-0270-4b44-bfda-069420898f39/key/twcg-1324_global_apps_nav_ipm_to_postoffice
// Poster: https://hello.atlassian.net/wiki/spaces/Growth/pages/6137140687/Migrate+Global+Apps+Nav+Recommendation+IPM+Surface+to+Post+Office+TWCG-1324+Project+Poster
export const TWCG_1324_GLOBAL_APPS_NAV_IPM_TO_POSTOFFICE = 'twcg-1324_global_apps_nav_ipm_to_postoffice';

// https://switcheroo.atlassian.com/ui/gates/225bbb2b-ee14-4242-b3af-74794a11b89b/key/rovo_chat_refresh_v1_experiment
export const ROVO_CHAT_REFRESH_V1_EXPERIMENT = 'rovo_chat_refresh_v1_experiment';

export const TEAMS_APP_LANDING_APP_PEOPLE_BUTTON_EXPERIMENT = 'teams_app_landing_app_people_button_experiment';

// https://switcheroo.atlassian.com/ui/gates/451e9377-b129-4541-836e-5da6564bfe4f/key/townsquare_3p_sl-clicked_feed_results_experiment
// Poster: https://hello.atlassian.net/wiki/x/vVP4WQE
export const HOME_FEEDS_3P_SL_CLICKED_EXPERIMENT = 'townsquare_3p_sl-clicked_feed_results_experiment';

// https://switcheroo.atlassian.com/ui/gates/753cc05b-a6e4-4a75-9904-9c62de861e8c/key/team_lens_in_atlassian_home
export const TEAM_LENS_IN_ATLASSIAN_HOME_EXPERIMENT = 'team_lens_in_atlassian_home';

// Verified teams in for you experiment - exposure only fires when recommendedTeams query has results
export const VERIFIED_TEAMS_IN_FOR_YOU_EXPERIMENT = 'verified_teams_in_for_you';

// Teams recommendations for you experiment - exposure only fires when rovo teams recommendations are cached.
export const TEAMS_RECOMMENDATIONS_FOR_YOU_EXPERIMENT = 'recommended_teams_in_for_you_page';

export const PERSONALISED_INVITE_NOTIFICATIONS_M2_EXPERIMENT = 'twcg-460-personalised-invite-notifications-m2';

export const USER_PROFILE_REFRESH_EXPERIMENT = 'user_profile_refresh_experiment';

// https://switcheroo.atlassian.com/ui/gates/048576dc-2aa1-48c4-b958-33de9d609284/key/navx_uc_trello_in_home
export const NAVX_UC_TRELLO_IN_HOME_EXPERIMENT = 'navx_uc_trello_in_home';

// Make sure you add your experiment to the list of valid experiments
export const experiments = {
	ATLAS_JIRA_GET_ATLAS_FREE,
	ATLAS_JIRA_SEARCH_JIRA_ISSSUES,
	FOLLOWERS_ON_PROJECT_EXPERIMENT,
	ROVO_SEARCH_COMPARE_RESULTS_PASS_THROUGH_RATE,
	NAV_REFRESH_FREE_CUSTOMERS_EXP,
	NAV_REFRESH_NEW_CUSTOMERS_EXP,
	NAV_REFRESH_NEW_CUSTOMERS_X_EXP,
	METRICS_IMPROVEMENTS_SEQ_EXPERIMENT,
	PROJECTS_NATIVE_INTEGRATION_WITH_JIRA,
	TWCG_1324_GLOBAL_APPS_NAV_IPM_TO_POSTOFFICE,
	ROVO_CHAT_REFRESH_V1_EXPERIMENT,
	TEAMS_APP_LANDING_APP_PEOPLE_BUTTON_EXPERIMENT,
	TOWNSQUARE_STARRED_FEED,
	HOME_FEEDS_3P_SL_CLICKED_EXPERIMENT,
	TEAM_LENS_IN_ATLASSIAN_HOME_EXPERIMENT,
	NAVX_UC_FREQUENCY_ORDERING_AND_OVERFLOW,
	VERIFIED_TEAMS_IN_FOR_YOU_EXPERIMENT,
	TEAMS_RECOMMENDATIONS_FOR_YOU_EXPERIMENT,
	PERSONALISED_INVITE_NOTIFICATIONS_M2_EXPERIMENT,
	USER_PROFILE_REFRESH_EXPERIMENT,
	NAVX_UC_TRELLO_IN_HOME_EXPERIMENT,
} as const;

export type ExperimentKeys = keyof typeof experiments;
export type ExperimentNames = (typeof experiments)[ExperimentKeys];
